define([
	"dojo/aspect",
	"dijit/popup",
	"csi/html"
], function(aspect,popup,html) {

	var ATTR = html.registerDataAttribute("DATA_AUTOMATION", "automation");
	var ITERATIONS = 3;
	var SETFUNC = "_setDataCsiAutomationAttr";

	function _getAutomationId(w) {
		var i = 0;
		var id;

		// limit number of iterations so that performance is not affected for deeply buried widgets, and the main reason for this
		// is to support composite toolbar plugins that contain multiple widgets, such as custom views plugin that contains button
		// and drop-down. The current value of 3 may even be too many, but being safe.
		while (w && (++i <= ITERATIONS)) {
			if (id = w.get(ATTR)) {
				return id;
			}

			w = w.getParent();
		}

		return null;
	}

	aspect.after(popup, "open", function(/*__OpenArgs*/args) {
		// summary: if wrapper needs to be created, then do so and add data attribute so automation can associate popup with original widget
		var id = _getAutomationId(args.parent);
		if (id) {
			args.popup.domNode.setAttribute(ATTR, id);
		}
	}, true);

	return {
		params: function(/*String*/viewKey, /*String*/widgetType, /*String*/widgetValue, /*Object?*/obj) {
			// summary: adds the parameters necessary to support automation to the given obj if passed, otherwise creates a new object with the
			// those parameters. In either case, return the object.
			var ids = [];

			if (widgetType) ids.push(widgetType);
			if (viewKey) ids.push(viewKey);
			if (widgetValue) ids.push(widgetValue);

			obj = obj || {};
			obj[ATTR] = ids.join("-");

			// this assures that attribute is mapped to widget domNode rather than focusNode, shorthand for "domNode". See dijit/_WidgetBase for
			// behavior of set functions.
			obj[SETFUNC] = "";

			return obj;
		}
	};
});
